import {Injectable} from '@angular/core';
import {MIHttpClientService} from './mi-http-client.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {isNil} from 'lodash-es';
import {ICountry} from './components/address/country';
import {sortByField} from './custom-rxjs-operators';
import {IdName} from "./common-interfaces";

export interface IState {
  id: number;
  stateName: string;
  abbreviation: string;
  cities?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class CountryStatesService {
  constructor(
    private miClient: MIHttpClientService,
  ) {
  }

  getCountries(): Observable<ICountry[]> {
    return this.miClient.get<ICountry[]>('countries');
  }

  getCountriesAsIdName(): Observable<IdName[]> {
    return this.miClient.get<ICountry[]>('countries').pipe(
      map (ret => ret.map((country) =>
        ({
          id: country.id,
          name: country.countryName,
          })
      )));
  }

  getSortedStatesForCountry(countryId: number): Observable<IState[]> {
    return this.miClient.get<IState[]>('states/byCountry/' + countryId)
      .pipe(sortByField('stateName'));
  }

  getSortedStatesWithCitiesForCountry(countryId: number): Observable<IState[]> {
    const countryIdNumber: number = +countryId;
    return this.miClient.get<IState[]>('states/byCountry/' + countryIdNumber + '?withCities=true')
      .pipe(
        map(results => results.filter(state => !isNil(state.cities))),
        sortByField('stateName'));
  }

}
